import React from 'react';

// PuzzleSelectionScreen Component: Allows players to select a puzzle
const PuzzleSelectionScreen = ({ puzzles, setSelectedPuzzle, setCurrentScreen }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full p-4">
      <h2 className="text-4xl font-extrabold mb-8 text-pink-600 text-center">Select Your Puzzle</h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-6 w-full max-w-7xl">
        {/* Map through the puzzles array to display each puzzle as a selectable card */}
        {puzzles.map((puzzle) => (
          <div
            key={puzzle.id}
            onClick={() => {
              setSelectedPuzzle(puzzle);
              setCurrentScreen('previewPuzzle');
            }}
            className="bg-white rounded-xl shadow-2xl p-4 flex flex-col items-center cursor-pointer transform transition duration-300 hover:scale-105 hover:shadow-pink-300 border-4 border-orange-300"
          >
            <img
              src={puzzle.imageUrl}
              alt={puzzle.name}
              className="w-24 h-24 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-32 lg:h-32 rounded-full object-cover mb-2 border-4 border-pink-400"
            />
            <h3 className="text-lg font-semibold text-center text-gray-800">{puzzle.name}</h3>
          </div>
        ))}
      </div>

      <button
        onClick={() => setCurrentScreen('leaderboard')}
        className="mt-10 bg-gradient-to-r from-orange-500 to-pink-500 text-white font-bold py-3 px-6 rounded-lg shadow-lg hover:from-orange-600 hover:to-pink-600 transition duration-300 transform hover:scale-105 text-xl"
      >
        View Leaderboard
      </button>
    </div>
  );
};

export default PuzzleSelectionScreen;
